import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SeverityCountBadge',
  props: {
    severity: null,
    count: null
  },
  setup(__props: any) {



const STYLES: Record<'high' | 'medium' | 'low', string> = {
  high: 'tw:bg-vuln-high-light tw:text-vuln-high tw:border-vuln-high/40',
  medium: 'tw:bg-vuln-medium-light tw:text-[#a87f00] tw:border-vuln-medium/50',
  low: 'tw:bg-vuln-low-light tw:text-vuln-low tw:border-vuln-low/40',
};

return { __sfc: true,STYLES }
}

})